import { useFeatureFlags } from "@/configs/featureFlag";

/**
 * 不動産調査依頼（R.E.REPO）を使えるか。
 * LaunchDarkly のフラグ real-estate-research-request が true のときだけ、画面と入口（サイドバー・マイページ・地図）を出す。
 * 依頼の送信先（API・Slack）がつながるまでは、本番ではオフにしておく。
 */
export const useRealEstateResearchRequestEnabled = (): boolean => {
  const { realEstateResearchRequest } = useFeatureFlags();
  return realEstateResearchRequest === true;
};
